import { CreateElement } from 'vue'
import { RouteConfig, Route } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'

import { lkFilePermissions as Permissions } from '@/helpers/enums/permission-models'
import * as TYPES from '@/helpers/enums/view-types'
import { FILES_ROUTES as ROUTES } from './utils'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

export { MENU as MENU_FILES } from './utils'

const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'files',
    name: ROUTES.LAYOUT,
    redirect: { name: ROUTES.LIST },
    meta: { authorized: true },
    async beforeEnter(to, from, next) {
      const { registerModule } = await import(
        /* webpackChunkName: "files.store" */
        './store'
      )
      registerModule(options)
      next()
    },
    component: {
      name: 'view-files-layout',
      render: (h: CreateElement) => h('router-view'),
    },
    children: [
      {
        path: '',
        name: ROUTES.LIST,
        meta: {
          permission: Permissions.read,
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "files.list" */
          './FilesList.vue'
        ),
      },
      {
        path: ':id(\\d+)',
        name: ROUTES.VIEW,
        meta: {
          permission: Permissions.read,
        },
        props: ({ params: p }: Route) => ({ ...p, viewType: TYPES.VIEW }),
        component: (): PromiseVue => import(
          /* webpackChunkName: "files.view" */
          './FilesView.vue'
        ),
      },
      {
        path: ':id(\\d+)/edit',
        name: ROUTES.EDIT,
        props: ({ params: p }: Route) => ({ ...p, viewType: TYPES.EDIT }),
        meta: {
          permission: Permissions.edit,
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "files.view" */
          './FilesView.vue'
        ),
      },
      {
        path: 'create',
        name: ROUTES.CREATE,
        props: () => ({ viewType: TYPES.CREATE }),
        meta: {
          permission: Permissions.create,
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "files.view" */
          './FilesView.vue'
        ),
      },
    ],
  },
]

const createModule = (options: Options) => {
  const routes = createRoutes(options)
  return routes
}

export default createModule
